class AnnouncementBar extends HTMLElement {
    constructor() {
        super();
        this.elWrapper = this.querySelector('.announcement-bar__wrapper');
        this.elElements = this.querySelector('.announcement-bar__elements');
        this.data = document.querySelector('[data-announcement-bar]');
        try {
            this.data = JSON.parse(this.data.innerText);
            this.init();
        } catch (error) {
            this.remove();
        }
    }

    init() {
        this.elWrapper.style.backgroundColor = this.data.settings.color_bg;
        this.data.blocks.forEach(block => {
            let blockTemplate = '';
            if (block.link && block.link != '') {
                blockTemplate = `
                    <li class="announcement-bar__element">
                        <a href="${block.link}" class="announcement-bar__link">
                            <p class="announcement-bar__message" style="--announcement-bar-color: ${this.data.settings.color_font}">${block.text}</p>
                        </a>
                    </li>
                `;
            } else {
                blockTemplate = `
                    <li class="announcement-bar__element">
                        <p class="announcement-bar__message" style="--announcement-bar-color: ${this.data.settings.color_font}">${block.text}</p>
                    </li>
                `;
            }
            this.elElements.insertAdjacentHTML('beforeend', blockTemplate);
        });

        setTimeout(() => {
            let new_min_height = this.clientHeight ? this.clientHeight : 52;
            this.elElements.style.minHeight = `${new_min_height}px`;
            if (this.data.blocks.length > 1) {
                this.classList.add('announcement-bar--initialized');
                this.querySelector('.announcement-bar__element').classList.add('announcement-bar__element--showing');
                this.initInterval();
            }
        }, 500);

    }

    initInterval() {
        this.interval = this.data.settings.change_interval;
        this.firstSlide = this.querySelector('.announcement-bar__element');
        setInterval(this.slide.bind(this), this.interval);
    }

    slide() {
        this.beforeSlide = document.querySelector('.announcement-bar__element--showing');
        if (this.beforeSlide) {
            this.beforeSlide.classList.remove('announcement-bar__element--showing');
            this.nextSlide = this.beforeSlide.nextElementSibling;
            if (this.nextSlide) {
                this.nextSlide.classList.add('announcement-bar__element--showing')
            } else {
                this.firstSlide.classList.add('announcement-bar__element--showing');
            }
        } else {
            this.firstSlide.classList.add('announcement-bar__element--showing');
        }
    }

}

customElements.define('announcement-bar', AnnouncementBar);